// extracted by mini-css-extract-plugin
export var closed = "_gw-1";
export var resizer = "_gw-0";